<template>
  <div class="password-requirement-container">
    <p>Make sure your password has at least;</p>

    <ul>
      <li :class="{ passwordSuccess: checkPasswordIncludeNumber(password) }">
        One number
      </li>
      <li
        :class="{
          passwordSuccess: checkPasswordIncludeSpecialCharacter(password)
        }"
      >
        One special character
      </li>
      <li :class="{ passwordSuccess: checkPasswordLength(password) }">
        8 characters minimum
      </li>
      <li :class="{ passwordSuccess: checkPasswordIncludeUppercase(password) }">
        One uppercase character
      </li>
    </ul>
  </div>
</template>

<script>
import {
  passwordLengthAboveEight,
  passwordIncludesOneNumber,
  passwordIncludesOneSpecialCharacter,
  passwordIncludesOneUppercase
} from "../../utils/index";
export default {
  props: {
    password: {
      type: String,
      default: ""
    }
  },
  methods: {
    checkPasswordLength(password) {
      return passwordLengthAboveEight(password);
    },

    checkPasswordIncludeNumber(password) {
      return passwordIncludesOneNumber(password);
    },

    checkPasswordIncludeSpecialCharacter(password) {
      return passwordIncludesOneSpecialCharacter(password);
    },
    checkPasswordIncludeUppercase(password) {
      return passwordIncludesOneUppercase(password);
    }
  }
};
</script>

<style lang="scss" scoped>
.password-requirement-container {
  background-color: #e9edfb;
  border-radius: 6px;
  padding: 10px 20px;

  p {
    color: #2f2f2b;
    font-size: 11px;
  }

  ul {
    list-style-type: disc;
    padding-left: 10px;
    font-size: 11px;
  }

  .passwordSuccess {
    color: rgb(26, 199, 26);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resuables/password-requirement.vue